import {
    BULLETIN_REQUEST,
    BULLETIN_ERROR,
    FETCH_BULLETINS_SUCCESS,
    CREATE_BULLETIN_SUCCESS,
    UPDATE_BULLETIN_SUCCESS,
    DELETE_BULLETIN_SUCCESS
} from "./actions";

const initialState = {
    bulletins: [],
    loading: false,
    error: null
};

export default function bulletinReducer(state = initialState, action) {
    switch (action.type) {
        case BULLETIN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case BULLETIN_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case FETCH_BULLETINS_SUCCESS:
            return {
                ...state,
                loading: false,
                bulletins: action.payload
            };

        case CREATE_BULLETIN_SUCCESS:
            return {
                ...state,
                loading: false,
                bulletins: [action.payload, ...state.bulletins]
            };

        case UPDATE_BULLETIN_SUCCESS:
            return {
                ...state,
                loading: false,
                bulletins: state.bulletins.map(b =>
                    (b._id === action.payload._id || b.id === action.payload.id)
                        ? action.payload
                        : b
                )
            };

        case DELETE_BULLETIN_SUCCESS:
            return {
                ...state,
                loading: false,
                bulletins: state.bulletins.filter(b =>
                    b._id !== action.payload && b.id !== action.payload
                )
            };

        default:
            return state;
    }
}
